export class StringUtil {

  static abreviar(texto: string, max: number): string {
    if ( texto && texto.length > max ) {
      return texto.substr(0, max) + '...';
    }
    return texto;
  }

  static comecaComNumero(texto: string, digitosAValidar?: number) {
    if ( texto && texto.length <= digitosAValidar ) {
      digitosAValidar = texto.length;
    }
    const textoAValidar = texto.substr(0, digitosAValidar);
    const isnum = /^\d+$/.test(textoAValidar);

    return isnum;
  }

  static getRandomInt(): number {
    const min = 1;
    const max = 99999999;
    return Math.floor(Math.random() * (max - min) + min);
  }

  static extrairNumeros(texto: string): number {
    if ( !texto ) {
      return null;
    }

    try {
      const numberPattern = /\d+/g;
      const _number = texto.match( numberPattern ).join('');
      return Number.parseInt(_number);
    }
    catch (e) {
      console.error(e);
      return null;
    }
  }

  static extrairNumerosMantendoZeroAEsquerda(texto: string): string {
    if ( !texto ) {
      return null;
    }

    try {
      const numberPattern = /\d+/g;
      const _number = texto.match( numberPattern ).join('');
      return _number;
    }
    catch (e) {
      console.error(e);
      return null;
    }    
  }

  static validarCpf(cpf: string): boolean {
    const _cpf = StringUtil.extrairNumerosMantendoZeroAEsquerda(cpf);
    if ( ('' + _cpf).length !== 11 ) {
      return false;
    }

    return true;
  }

  static validarUrl(value: string): boolean {
    if ( !value ) {
      return false;
    }

    let valid = true;
    try {
        let validUrl =  new URL(value);
        if(validUrl.host == "" && validUrl.origin == "null") {
          valid = false;
        }
    } catch {
      valid = false;
    }

    return valid; 
  }

  static validarEmail(value: string): boolean {
    if ( !value ) {
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  }

  static getExtensaoDoArquivo(nomeArquivo: string): string {
    if ( !nomeArquivo ) {
      return '';
    }

    return nomeArquivo.substring(nomeArquivo.lastIndexOf('.')+1, nomeArquivo.length) || nomeArquivo;
  }

  static getS3UrlPrefixo(): string {
    return '';
  }

  static primeiraLetraMaiuscula(valor: string): string {
    try {
      return valor[0].toUpperCase() + valor.slice(1);
    }
    catch (e) {
      return valor;
    }
  }

  /**
   * 
   * @param strA 
   * @param strB 
   * @returns 
   * 1 se string1for maior (maior na ordem alfabética) do questring2
    -1 se string1for menor (menor na ordem alfabética) do questring2
     0 se string1e string2 são iguais na ordem alfabética
   */
  static ordenarAlfabeticamente(strA: string, strB: string): number {
    if ( !strA ) {
      return -1;
    }
    else if ( !strB ) {
      return 1;
    }

    return strA.localeCompare(strB);
  }

}
